/**
 * A termék neve. Ez az a név, ami akkor jelenik meg, ha a klub nem adott meg
 * sajátot - a klub neve, színe és címere mindenhol elsőbbséget élvez, a márka
 * csak a tartalék (lásd docs/branding, "Amit ne csinálj").
 */
export const APP_NAME = 'Portero';

/** A klub neve, ha megadta; egyébként a termék neve. */
export const displayName = (clubName?: string | null): string =>
  clubName?.trim() || APP_NAME;
